import { skipLogicJA } from "@common/translations/skip-logic/ja";
import { commonTranslationJA } from "@common/translations/ja";
import { fhqDesignToolEN } from "./en";

export const fhqDesignToolJA: Record<keyof typeof fhqDesignToolEN, string> = {
  ...commonTranslationJA,
  ...skipLogicJA,
  'Failed to get questionnaires': 'Failed to get questionnaires',
  'Failed to delete questionnaire': 'Failed to delete questionnaire',
  'Save': 'Save',
  'New Questionnaire': 'New Questionnaire',
  'Delete Questionnaire': 'Delete Questionnaire',
  'Copy Questionnaire': 'Copy Questionnaire',
  'Export': 'Export',
  'Import': 'Import',
  'Are you sure you want to delete this questionnaire?': 'Are you sure you want to delete this questionnaire?',
  'Questionnaire Name': 'Questionnaire Name',
  'Please select a questionnaire': 'Please select a questionnaire',
  'Are you sure you want to proceed without saving?': 'Are you sure you want to proceed without saving?',
  'Failed to update questionnaire': 'Failed to update questionnaire',
  'Changes have been successfully applied': 'Changes have been successfully applied',
  'Exit URL': 'Exit URL',
  'URL patient should be directed to after saving or submitting questionnaire': 'URL patient should be directed to after saving or submitting questionnaire',
  'Configuration': 'Configuration',
  'Help Text': 'Help Text',
  'Login Page Title': 'Login Page Title',
  'Login Page Instructions': 'Login Page Instructions',
  'Sign Up Page Instructions': 'Sign Up Page Instructions',
  'Summary Title': 'Summary Title',
  'Summary Text': 'Summary Text',
  'Submit Popup Title': 'Submit Popup Title',
  'Submit Popup Text': 'Submit Popup Text',
  'Email & Reminders': 'Email & Reminders',
  'External URL': 'External URL',
  'Public facing URL that will replace the hostname/internal IP address of the server': 'Public facing URL that will replace the hostname/internal IP address of the server',
  'Logo URL': 'Logo URL',
  'URL of logo to be displayed in questionnaire and on login screen': 'URL of logo to be displayed in questionnaire and on login screen',
  'Questionnaire Language': 'Questionnaire Language',
  'English (United States)': 'English (United States)',
  'Failed to get folders': 'Failed to get folders',
  'Generic Link Default Folder': 'Generic Link Default Folder',
  'Individual Data Folders': 'Individual Data Folders',
  'Pedigree Data Folders': 'Pedigree Data Folders',
  'Generic Link': 'Generic Link',
  'Patient First Name': 'Patient First Name',
  'Patient Last Name': 'Patient Last Name',
  'Patient Email': 'Patient Email',
  'Invite Datasheet': 'Invite Datasheet',
  'Show Print Answers': 'Show Print Answers',
  'Show Consent': 'Show Consent',
  'Show Pedigree': 'Show Pedigree',
  'Individual': 'Individual',
  'Family': 'Family',
  'Questionnaire Type': 'Questionnaire Type',
  'Invited': 'Invited',
  'Reviewed': 'Reviewed',
  'Incomplete Questionnaires': 'Incomplete Questionnaires',
  'Submitted Questionnaires': 'Submitted Questionnaires',
  'Rename Pedigree on Submit': 'Rename Pedigree on Submit',
  'Select Delimiter': 'Select Delimiter',
  'Field 1': 'Field 1',
  'Field 2': 'Field 2',
  'Move on Invitation Sent': 'Move on Invitation Sent',
  'Choose Target Folder': 'Choose Target Folder',
  'Set the action to occur when the patient submits the questionnaire': 'Set the action to occur when the patient submits the questionnaire',
  'Lock on submit': 'Lock on submit',
  'Run risk on submit': 'Run risk on submit',
  'Edit Risk Settings': 'Edit Risk Settings',
  "Set the actions to occur when you set invite status to 'Reviewed'": "Set the actions to occur when you set invite status to 'Reviewed'",
  'Send email to patient': 'Send email to patient',
  'Send email to staff': 'Send email to staff',
  'Move to Folder': 'Move to Folder',
  'Transmit Pedigree PDF to EMR': 'Transmit Pedigree PDF to EMR',
  'Select Folder': 'Select Folder',
  'Make incomplete questionnaires inactive': 'Make incomplete questionnaires inactive',
  'unintendedIncompleteInactive': 'Turning off "Incomplete Questionnaires Inactive" status will cause unintended reminders to be sent. To turn off this status action ensure that "Automated Reminders" is turned off before making this change.',
  'After This Date': 'After This Date',
  'Choose Field': 'Choose Field',
  'Make Inactive After': 'Make Inactive After',
  'Days': 'Days',
  'Select Field': 'Select Field',
  'Criteria and Risk Settings on Submit': 'Criteria and Risk Settings on Submit',
  'Cancel': 'Cancel',
  'Criteria:': 'Criteria:',
  'Risk Assessment Models:': 'Risk Assessment Models:',
  'Always show family pages': 'Always show family pages',
  'Show family pages only if condition below is true': 'Show family pages only if condition below is true',
  'Confirmation Message': 'Confirmation Message',
  'Are you sure you want to delete this page?': 'Are you sure you want to delete this page?',
  'Are you sure you want to delete this field?': 'Are you sure you want to delete this field?',
  'Are you sure you want to delete this text block?': 'Are you sure you want to delete this text block?',
  'Pages': 'Pages',
  'Field': 'Field',
  'Operator': 'Operator',
  'Value': 'Value',
  'AND/OR': 'AND/OR',
  'AND': 'AND',
  'OR': 'OR',
  'Type': 'Type',
  'Page Description': 'Page Description',
  'Fields': 'Fields',
  'Select': 'Select',
  'Tooltip': 'Tooltip',
  'Required': 'Required',
  'Read-only': 'Read-only',
  'Text Type': 'Text Type',
  'Checkbox Type': 'Checkbox Type',
  'Text': 'Text',
  'Static text': 'Static text',
  Checkbox: 'Checkbox',
  Toggle: 'Toggle',
  'Dropdown Options': 'Dropdown Options',
  'Dropdown': 'Dropdown',
  'Radio': 'Radio',
  'Search dropdown': 'Search dropdown',
  'Dropdown Type': 'Dropdown Type',
  'Allow duplications': 'Allow duplications',
  'Table Options': 'Table Options',
  'Dropdown Values Display and Mapping': 'Dropdown Values Display and Mapping',
  'Dropdown Value': 'Dropdown Value',
  'FHQ Display Value': 'FHQ Display Value',
  'Display in FHQ': 'Display in FHQ',
  'Delete': 'Delete',
  'Add Row': 'Add Row',
  'Ins Row': 'Ins Row',
  'Skip Logic': 'Skip Logic',
  'Show Always': 'Show Always',
  'Show only if condition below is true': 'Show only if condition below is true',
  'skipLogicDescriptionField': 'This field will only be visible if the conditions below are true (i.e. show the field only if...)',
  'skipLogicDescriptionPage': 'This page will only be visible if the conditions below are true (i.e. show the page only if...)',
  'skipLogicDescriptionTextBlock': 'This text block will only be visible if the conditions below are true (i.e. show the page only if...)',
  'Invitation Email' : 'Invitation Email',
  'Submit Email': 'Submit Email',
  'Unfinished Email': 'Unfinished Email',
  'Reminder Email': 'Reminder Email',
  'Patient Email Settings': 'Patient Email Settings',
  'Automated Reminder Settings': 'Automated Reminder Settings',
  'Failed to get questionnaire': 'Failed to get questionnaire',
  'Failed to get email templates': 'Failed to get email templates',
  "Turn on Automated Reminders": "Turn on Automated Reminders",
  "Remind Every": "Remind Every",
  "Weeks": "Weeks",
  "Max Number of Reminders to Send": "Max Number of Reminders to Send",
  "Before this date": "Before this date",
  'One or both of the uncompleted/inactive status configurations must be completed in order to turn on Automated Reminders': 'One or both of the uncompleted/inactive status configurations must be completed in order to turn on Automated Reminders',
  'Email to notify questionnaire submitted': 'Email to notify questionnaire submitted',
  'There are not valid emails:': 'There are not valid emails:',
  'The value should be from an integer': 'The value should be from an integer',
  'The value should be from': 'The value should be from',
  to: 'to',
  'Name is not unique': 'Name is not unique',
  'Failed to get page': 'Failed to get page',
  'EDITOR': 'EDITOR',
  'HTML': 'HTML',
  'Determine criteria for referral/testing': 'Determine criteria for referral/testing',
  'BRCAPro': 'BRCAPro',
  'MMRPro': 'MMRPro',
  'PANCPRO': 'PANCPRO',
  'MelaPro': 'MelaPro',
  'Tyrer-Cuzick': 'Tyrer-Cuzick',
  'PREMM': 'PREMM',
  'Gail': 'Gail',
  'Claus': 'Claus',
  'Use Competing Mortality for Tyrer-Cuzick': 'Use Competing Mortality for Tyrer-Cuzick',
  'Include data inputs in reports': 'Include data inputs in reports',
  'Field Description': 'Field Description',
  'All possible options are used': 'All possible options are used',
  'Final Notes': 'Final Notes',
  'Please use this page to tell us about any other family history that you have not already listed': 'Please use this page to tell us about any other family history that you have not already listed', 
  'You can also use this page for any questions or comments that you would like to share with your genetic counselor': 'You can also use this page for any questions or comments that you would like to share with your genetic counselor',
  'Please provide the number of blood relatives you have for each of the following relations':'When you continue past this page, you will not be able to modify these numbers',
  'You will be able to add or remove each relative one-by-one, however, in the subsequent sections': 'You will be able to add or remove each relative one-by-one, however, in the subsequent sections',
  'Please add the number of sons and/or daughters for each of your aunts/uncles': 'Please add the number of sons and/or daughters for each of your aunts/uncles',
  'Please add all family members who have cancer': 'Please add all family members who have cancer',
  'Please enter the information below regarding your half-sibling and which parent you share': 'Please enter the information below regarding your half-sibling and which parent you share',
  'Copy': 'Copy',
  'Failed to copy questionnaire': 'Failed to copy questionnaire',
  'Questionnaire has been successfully copied': 'Questionnaire has been successfully copied',
  'Failed to get field': 'Failed to get field',
  'Failed to get field with fieldName': 'Failed to get %{fieldName} field',
  'Failed to preload field': 'Failed to preload field',
  'The value should be greater than 0': 'The value should be greater than 0',
  'The value should be an integer': 'The value should be an integer',
  'Failed to create questionnaire': 'Failed to create questionnaire',
  'Failed to create basic questionnaire': 'Failed to create basic questionnaire',
  'Questionnaire has been successfully created': 'Questionnaire has been successfully created',
  'Datasheet Chooser': 'Datasheet Chooser',
  'Datasheet Format Folders': 'Datasheet Format Folders',
  'Affected family members': 'Affected family members',
  'changingAutomaticRemindersSettingsWarning': 'Changing Automated Reminders settings can cause unintended reminders to be sent, please ensure that the "Make incomplete questionnaires inactive" feature has been turned on before making these changes',
  'Allow import to create new fields': 'Allow import to create new fields',
  'Choose Fields to Import': 'Choose Fields to Import',
  'Select All': 'Select All',
  'Failed to load individual folders': 'Failed to load individual folders',
  'Failed to load pedigree folders': 'Failed to load pedigree folders',
  'Failed to check questionnaire name exists': 'Failed to check questionnaire name exists',
  'Failed to save imported questionnaire': 'Failed to save imported questionnaire',
  'Format has been successfully imported': 'Format has been successfully imported',
  'OK': 'OK',
  'Rename questionnaire': 'Rename questionnaire',
  'Loading': 'Loading',
  'Failed to export questionnaire': 'Failed to export questionnaire',
  'Export Questionnaire Format': 'Export Questionnaire Format',
  'will be exported': 'will be exported',
  'Option cannot be deleted': 'Option cannot be deleted',
  'Value cannot be changed': 'Value cannot be changed',
  'Failed to get Final Notes page data': 'Failed to get Final Notes page data',
  'Failed to get fields to import': 'Failed to get fields to import',
  'unsavedChangesMessage': 'Questionnaire was modified. Do you want to save the changes?',
  'Select Datasheet': 'Select Datasheet',
  'Spanish (Latin America)': 'Spanish (Latin America)',
  'There is a duplicated display value': 'There is a duplicated display value',
  'questionnaireHasErrors': 'Questionnaire has validation error(s). Please follow red tabs to fix them',
  'unsavedChangesMessageWithErrors': 'Questionnaire was modified. Please fix errors to save changes',
  'Proceed without saving': 'Proceed without saving',
  'Twin': 'Twin',
  'Consent': 'Consent',
  'Pedigree Symbols Formats': 'Pedigree Symbols Formats',
  'Pedigree Subtext Formats': 'Pedigree Subtext Formats',
  'Text Block': 'Text Block',
  'Text Display': 'Text Display',
  'Default Value': 'Default Value',
  'Questionnaire Active': 'Questionnaire Active',
  'Questionnaire Disabled': 'Questionnaire Disabled',
  'Failed to copy page': 'Failed to copy page',
  'Paste': 'Paste',
  'The delimiter is required' : 'The delimiter is required',
};